import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'sonner';
import { DocumentUpload } from './components/DocumentUpload';
import { FieldExtraction } from './components/FieldExtraction';
import { ProgressStepper } from './components/ProgressStepper';
type Screen = 'upload' | 'review';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('upload');
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const handleUpload = (file: File) => {
    setIsProcessing(true);
    setUploadedFile(file);
    // Simulate processing delay
    setTimeout(() => {
      setIsProcessing(false);
      setCurrentScreen('review');
    }, 1500);
  };
  const handleBack = () => {
    setCurrentScreen('upload');
    setUploadedFile(null);
  };
  const steps = [{
    label: 'Upload',
    status: currentScreen === 'upload' ? 'current' : 'completed'
  }, {
    label: 'Review',
    status: currentScreen === 'review' ? 'current' : 'upcoming'
  }, {
    label: 'Done',
    status: 'upcoming'
  }] as const;
  return <div className="min-h-screen w-full bg-gray-50 py-12 px-4" data-id="element-0">
      <Toaster position="top-right" richColors data-id="element-1" />

      <ProgressStepper steps={steps} data-id="element-2" />

      <AnimatePresence mode="wait" data-id="element-3">
        {currentScreen === 'upload' && <DocumentUpload key="upload" onUpload={handleUpload} isProcessing={isProcessing} data-id="element-4" />}
        {currentScreen === 'review' && uploadedFile && <FieldExtraction key="review" fileName={uploadedFile.name} onBack={handleBack} data-id="element-5" />}
      </AnimatePresence>
    </div>;
}